export function mergeListeners(...listeners) {
  return (...args) => {
    listeners.forEach(fn => fn?.(...args));
  };
}
